import React from "react";
import ReactDOM from "react-dom/client";
import { setAuthMode } from "@/api/authMode";
import { AdminApp } from "./AdminApp";
import "@/index.css";

// Must run before any module reads the mode (client.ts reads it lazily on
// 401, so import order is not fragile — but set it first anyway).
setAuthMode("admin-web");

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element missing");
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <AdminApp />
  </React.StrictMode>,
);
